import { useContext } from 'react';
import { MdClose } from 'react-icons/md';
import { AppContext } from '../App';
import logoWorded from '../assets/logo_worded.png';

export default function SideBar() {
  const appContext = useContext(AppContext);
  const links = [['Home', 'home'], ['Products & Services', 'services'], ['Our Clients', 'projects'], ['Place Inquiry', 'contact_us']];
  const goTo = (item) => { appContext.navTo({ item }); appContext.closeSideBar(); };

  return (
    <aside className="SideBar HospiumSideBar mShadow2" data-open={appContext.isSideBarOpen}>
      <div className="body mNoScrollBar">
        <div className="HospiumSideHeader"><img src={logoWorded} alt="Hospium" /><button onClick={appContext.closeSideBar} aria-label="Close menu"><MdClose /></button></div>
        <nav>{links.map(([label, item]) => <button key={item} data-active={appContext.navItem === item || (item === 'home' && !appContext.navItem)} onClick={() => goTo(item)}>{label}</button>)}</nav>
      </div>
    </aside>
  );
}
